import { render, staticRenderFns } from "./image_advert.vue?vue&type=template&id=073dba54&scoped=true"
import script from "./image_advert.vue?vue&type=script&lang=js"
export * from "./image_advert.vue?vue&type=script&lang=js"
import style0 from "./image_advert.vue?vue&type=style&index=0&id=073dba54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073dba54",
  null
  
)

export default component.exports